import TrezorConnect from "trezor-connect";
import { ethers } from "ethers";
import utils from "../lib/utils";

const VERSION_SUPPORTED_EIP1559 = "2.4.2";

const eventQueue = utils.createQueue();

const Account = (path) => {
  const getAddress = async () => {
    const result = await eventQueue.push(
      TrezorConnect.ethereumGetAddress.bind(TrezorConnect, { path })
    );
    if (!result.success) throw new Error(result.payload.error);
    return { address: result.payload.address };
  };

  const signTransaction = async (rawTx) => {
    const tx = {
      nonce: rawTx.nonce,
      gasLimit: rawTx.gas,
      to: rawTx.to,
      value: rawTx.value,
      data: rawTx.data,
      chainId: Number(rawTx.chainId) || 1,
    };
    const isEip1559 = await isEip1559Supported();
    if (isEip1559) {
      tx.maxFeePerGas = rawTx.maxFeePerGas;
      tx.maxPriorityFeePerGas = rawTx.maxPriorityFeePerGas;
    } else {
      tx.gasPrice = rawTx.maxFeePerGas;
    }
    const result = await eventQueue.push(
      TrezorConnect.ethereumSignTransaction.bind(TrezorConnect, {
        path,
        transaction: tx,
      })
    );
    if (!result.success) throw new Error(result.payload.error);
    result.payload.v = Number(result.payload.v);
    if (result.payload.v > 1) {
      result.payload.v -= 37;
    }
    result.payload.v = `0${result.payload.v}`;
    const signedTx = ethers.utils.serializeTransaction(
      {
        type: isEip1559 ? 2 : null,
        ...tx,
      },
      result.payload.r + result.payload.s.slice(2) + result.payload.v
    );
    const { hash: txHash } = ethers.utils.parseTransaction(signedTx);
    return { txHash, signedTx };
  };

  const getPubKey = async () => {};
  const sign = async (message) => {};
  const verifySignature = async (message, signature) => {};

  return {
    getAddress,
    getPubKey,
    sign,
    signTransaction,
    verifySignature,
  };
};

const Backend = () => {
  const genAccount = async (hdPath) => {
    return Account(hdPath);
  };

  const getAccount = async ({ hdPath }) => {
    return genAccount(hdPath);
  };

  const getAddresses = async (paths) => {
    const result = await eventQueue.push(
      TrezorConnect.ethereumGetAddress.bind(TrezorConnect, { bundle: paths })
    );
    if (!result.success) throw new Error(result.payload.error);
    return result.payload;
  };

  const cleanUp = async () => {};

  return {
    getAccount,
    getAddresses,
    cleanUp,
  };
};

Backend.create = async () => {
  try {
    await TrezorConnect.init({
      debug: window.location.hostname !== "app.unagii.com",
      popup: true,
      lazyLoad: false,
      manifest: {
        email: "support@unagii.com",
        appUrl: window.location.origin,
      },
    });
  } catch (error) {
    if (error.message !== "TrezorConnect has been already initialized") {
      throw error;
    }
    if (window.location.hostname !== "app.unagii.com") {
      console.error(error);
    }
  }
  return Backend();
};

const isEip1559Supported = async () => {
  const { payload } = await TrezorConnect.getFeatures();
  return (
    payload.model === "T" &&
    isVersionSupportedEip1559(
      `${payload.major_version}.${payload.minor_version}.${payload.patch_version}`,
      VERSION_SUPPORTED_EIP1559
    )
  );
};

const isVersionSupportedEip1559 = (current, target) => {
  current = current.split(".").map(Number);
  target = target.split(".").map(Number);
  if (current[0] > target[0]) return true;
  if (current[0] < target[0]) return false;
  if (current[1] > target[1]) return true;
  if (current[1] < target[1]) return false;
  return current[2] >= target[2];
};

export default Backend;
